module.exports = __webpack_public_path__ + "img/Hi-Life_logo.4e2dad1c.svg";